export default __webpack_public_path__ + "static/media/boost.519fad2b.mp3";